<template>
  <div class="content-box2">
    <!-- gitlist -->
    <Modal
      v-model="gitlist"
      width="900px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      :title="title"
      :closable="false"
    >
      <div class="content">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="90"
        >
          <FormItem prop="nickname" label="真实姓名">
            <Input
              v-model="formValidate.nickname"
              placeholder="请输入您的真实姓名"
              maxlength="20"
              show-word-limit
            ></Input>
          </FormItem>
          <FormItem label="头像上传" v-if="setting[2].show" :label-width="100" :prop="setting[2].must ? 'headPhoto' : ''">
            <Upload
              ref="upload"
              v-model="formValidate.headPhoto"
              :accept="'.jpg,.jpeg,.png'"
              :format="['jpg', 'jpeg', 'png']"
              :show-upload-list="false"
              :max-size="1024"
              :on-exceeded-size="handleMaxSize"
              class="upload"
              multiple
              type="drag"
              :action="$global.url + '/web/common/upload'"
              :on-success="periodicalLogoSuccess"
              style="display: inline-block"
              :style="formValidate.headPhoto ? 'width:200px;' : 'width:100px'"
            >
              <div
                style="width: 100px; height: 100px; line-height: 100px"
                v-if="!formValidate.headPhoto"
              >
                <Icon type="ios-camera" size="20"></Icon>
              </div>
              <img
                v-if="formValidate.headPhoto"
                :src="$global.imgUrl + formValidate.headPhoto"
                style="width: 200px; height: 200px; line-height: 200px"
              />
            </Upload>
          </FormItem>
          <FormItem label="性别"  v-if="setting[3].show" :prop="setting[3].must ? 'sex' : ''">
            <RadioGroup v-model="formValidate.sex">
              <Radio label="男">男</Radio>
              <Radio label="女">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="出生年份" v-if="setting[4].show" :prop="setting[4].must ? 'birthday' : ''">
            <DatePicker
              :transfer="true"
              type="year"
              :value="formValidate.birthday"
              v-model="formValidate.birthday"
              @on-change="formValidate.birthday = $event"
              placeholder="请选择"
            ></DatePicker>
          </FormItem>
          <FormItem label="民族" v-if="setting[5].show" :prop="setting[5].must ? 'nation' : ''">
            <Input
              v-model="formValidate.nation"
              placeholder="请输入民族"
            ></Input>
          </FormItem>
          <FormItem label="学历/学位" v-if="setting[6].show" :prop="setting[6].must ? 'eduVal' : ''">
            <Cascader
                v-model="formValidate.eduVal"
                :data="eduNewData"
                filterable
                @on-change="eduNewDataChange"
                style="width: 210px"
            ></Cascader>
            <span style="position:absolute;top:2px;left: 220px">
                <Checkbox
                label="在读"
                :disabled="inStudyDisabled"
                v-model="formValidate.inStudy"
                >在读</Checkbox
                >
            </span>
          </FormItem>
          <FormItem label="手机" prop="mobile">
            <Input
              v-model="formValidate.mobile"
              :disabled="true"
              placeholder="请输入您的手机号"
            ></Input>
          </FormItem>
          <FormItem label="QQ" v-if="setting[7].show" :prop="setting[7].must == 1 ? 'qq' : ''">
            <Input
              v-model="formValidate.qq"
              placeholder="请输入您的qq号"
            ></Input>
          </FormItem>
          <FormItem label="邮箱" prop="email">
            <Input
              v-model="formValidate.email"
              placeholder="请输入您的邮箱"
            ></Input>
          </FormItem>
          <FormItem label="工作单位" prop="unit">
            <Input
              v-model="formValidate.unit"
              placeholder="请输入您的工作单位"
            ></Input>
          </FormItem>
          <FormItem label="现任职位" v-if="setting[10].show" :prop="setting[10].must == 1 ? 'job' : ''">
            <Input
              v-model="formValidate.job"
              placeholder="请输入您的职位"
            ></Input>
          </FormItem>
          <!-- 2022-12 单位地址修改为二级级联 -->
          <FormItem label="单位地址" v-if="setting[11].show" :required="setting[11].must == 1">
            <div style="display: flex;">
              <FormItem 
                :prop="setting[11].must ? 'country' : ''">
                <Select 
                  style="width: 100px"
                  v-model="formValidate.country"
                  clearable
                  @on-change="(value) => resetUnitAddress(value, setting[11].must)">
                  <Option :value="0">国内</Option>
                  <Option :value="1">国外</Option>
                </Select>
              </FormItem>
              <FormItem 
                v-if="formValidate.country === 1" 
                class="address-input" 
                :prop="setting[11].must || formValidate.country === 1 ? 'address' : ''">
                <Input
                  v-model="formValidate.address"
                  placeholder="地址精确至市级"
                  maxlength="100"
                ></Input>
              </FormItem>
              <FormItem 
                v-if="formValidate.country === 0"
                class="address-input"
                :prop="setting[11].must || formValidate.country === 0 ? 'unitAddress' : ''">
                <Cascader
                  v-model="formValidate.unitAddress"
                  :data="unitList"
                  filterable
                  @on-change="unitAddressChange"
                ></Cascader>
              </FormItem>
            </div>
          </FormItem>
          <Form ref="formDynamics" style="margin-left: 10px;" :model="formDynamics" :label-width="80">
            <div
              v-for="(iteList, index) in formDynamics.titles"
              v-if="iteList.status"
              :key="index"
            >
              <div style="display: flex">
                <FormItem
                  :label="'职称'"
                  :rules="{
                    required: true,
                    type: 'number',
                    message: '填写职称',
                    trigger: 'change',
                  }"
                  :prop="'titles.' + index + '.levelOne'"
                >
                  <Select
                    v-model="iteList.levelOne"
                    placeholder="请选择一级"
                    :transfer="true"
                    @on-change="oneList($event, index)"
                    style="width: 200px"
                  >
                    <Option
                      v-for="ites in getOneList"
                      :value="Number(ites.value)"
                      :key="ites.value"
                      >{{ ites.label }}</Option
                    >
                  </Select>
                </FormItem>
                <div style="display: flex">
                  <FormItem
                    :label-width="10"
                    v-if="iteList.levelOne !='5'"
                    :rules="{
                      required: true,
                      message: '填写职称',
                      trigger: 'blur',
                    }"
                    :prop="'titles.' + index + '.levelTwo'"
                  >
                    <Input
                      v-model="iteList.levelTwo"
                      placeholder="填写职称"
                      style="width: 200px"
                    ></Input>
                  </FormItem>
                  <Button
                    type="error"
                    icon="md-remove"
                    v-if="index != 0"
                    @click="handleRerve(index)"
                    style="margin-left: 20px"
                    >删除</Button
                  >
                </div>
              </div>
            </div>
            <FormItem>
              <Button class="add" type="info" icon="md-add" @click="titlesAdd"
                >添加</Button
              >
            </FormItem>
          </Form>
          <Form ref="formDynamic" style="margin-left: 10px;" :model="formDynamic" v-if="setting[13].show" :label-width="80">
            <!-- 研究方向 -->

            <div v-for="(it, index) in formDynamic.items" :key="index">
              <div style="display: flex">
                <FormItem
                  label="学科领域"
                  :rules="setting[13].must ? {
                    required: true,
                    type: 'array',
                    message: '请选择学科领域',
                    trigger: 'blur',
                  } : '' "
                  :prop="setting[13].must ? `items.${index}.levelTotal` : ''"
                >
                  <Cascader
                    v-model="it.levelTotal"
                    @on-change="subjectChange"
                    :data="subjectList"
                    style="width: 400px"
                    :clearable="false"
                  ></Cascader>
                </FormItem>
                <Button
                  v-if="index != 0"
                  type="error"
                  icon="md-remove"
                  @click="handleRemove(index)"
                  style="margin-left: 20px"
                  >移除</Button
                >
              </div>
            </div>
            <FormItem>
              <Button class="add" type="info" icon="md-add" @click="handleAdd()"
                >添加</Button
              >
              <!-- <Button type="dashed" long @click="handleAdd" icon="md-add">添加</Button> -->
            </FormItem>
          </Form>
          <FormItem label="研究方向" v-if="setting[14].show" :prop="setting[14].must ? 'researchDirection' : ''">
            <Input
              v-model="formValidate.researchDirection"
              placeholder="请输入研究方向"
            ></Input>
          </FormItem>
          <FormItem label="个人简介" v-if="setting[15].show" :prop="setting[15].must ? 'profile' : ''">
            <Input
              :maxlength="50"
              show-word-limit
              type="textarea"
              v-model="formValidate.profile"
              placeholder="请输入个人简介"
              style="max-width: 600px"
            />
          </FormItem>
        </Form>
        <Button
          @click="cancive"
          class="save"
          style="
            background: #ffffff;
            color: #333333;
            float: left;
            margin-left: 28%;
            margin-right: 3%;
          "
          size="large"
          >取消</Button
        >

        <Button
          class="save"
          size="large"
          type="primary"
          style="float: left"
          @click="handleSubmit('formValidate', setting[13].show && setting[13].must ? 'formDynamic' : 'formValidate', 'formDynamics')"
          >提交</Button
        >
      </div>
      <span style="width: 100%; height: 30px; background-color: #000"></span>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import Vue from "vue";
import {
  select,
  empty,
  upload,
  num,
  passwords,
  identity2,
  emptyls,
} from "@/const/formValidate.js";
import { sync } from "rimraf";
var vm = this;
export default {
  props: ["livsTop", "livstGithave", "toplist"],
  //  gitlist: ,
  data() {
    return {
      inStudyDisabled: false,
      eduNewData: [],
      setting: [],
      gitlist: this.livsTop,
      cert: false,
      title: this.toplist == 1 ? "完善个人信息" : "完善注册信息",
      viflist: false,
      ListTop: true,
      gradeList: [
        { id: "1", name: "正高级" },
        { id: "2", name: "副高级" },
        { id: "3", name: "中级" },
        { id: "4", name: "初级" },
      ],

      formDynamic:
        this.toplist == 1
          ? {
              items: [],
            }
          : {
              items: [
                {
                  subjectName: "",
                  subtwoName: "",
                  subthreeName: "",
                  index: 0,
                  titleTwoLists: [],
                  vahrsThree: [],
                  status: 1,
                  id: "",
                  levelOneName: "",
                  levelThreeName: "",
                  levelTwoName: "",
                  userId: "",
                  levelTwo: "",
                },
              ],
            },
      formDynamics:
        this.toplist == 1
          ? {
              titles: [],
            }
          : {
              titles: [
                {
                  nickname: "",
                  sex: "",
                  birthday: "",
                  nation: "",
                  nativeProvince: "",
                  nativeCity: "",
                  province: "",
                  city: "",
                  eduVal: "",
                  mobile: "",
                  qq: "",
                  email: "",
                  unit: "",
                  department: "",
                  title: "",
                  subjectArray: "",
                  profile: "",
                  id: "",
                  userId: "",
                },
              ],
            },
      getOneList: [], //职称
      formValidate: {
        nickname: "",
        sex: "",
        birthday: "",
        nation: "",
        nativeProvince: "",
        nativeCity: "",
        eduVal: "",
        mobile: "",
        qq: "",
        email: "",
        unit: "",
        department: "",
        idCard: "",
        title: "",
        subjectArray: "",
        profile: "",
        id: "",
        userId: "",
        headPhoto: "",
        researchDirection: "", //自定义研究方向
        country: "",
        address: "",
        unitAddress: [],
        province: "",
        city: "",
      },
      ruleValidate: {
        // nickname: [
        //   { required: true, message: "请输入您的姓名", trigger: "blur" },
        //   {
        //     pattern: /^\S.*\S$|(^\S{0,1}\S$)/,
        //     message: "只能输入汉字",
        //   },
        // ],
        nickname: emptyls("姓名"),
        nation: empty("民族"),
        mobile: empty("手机"),
        email: empty("邮箱"),
        qq: empty("QQ"),
        sex: select("性别"),
        birthday: empty("出生年份"),
        eduVal: empty("学历/学位"),
        unit: empty("单位名称"),
        country: [
          {
            required: true,
            type: "number",
            message: "请选择单位地址",
            trigger: "change",
          },
        ],
        address: empty("单位地址详细信息"),
        unitAddress: empty("单位地址详细信息"),
        job: empty("现任职位"),
        // idCard: identity2("身份证"),
        headPhoto: empty("头像"),
        profile: empty("个人简介"),
        researchDirection: empty("研究方向"),
        nativeProvince: [
          { required: true, message: "（省）不能为空", trigger: "change" },
        ],
        nativeCity: [
          { required: true, message: "（市）不能为空", trigger: "change" },
        ],
        province: [
          { required: false, message: "（省）不能为空", trigger: "change" },
        ],
        city: [
          { required: false, message: "（市）不能为空", trigger: "change" },
        ],
      },
      cityList: [],
      cityList1: [],
      provinceList: [],
      selectData: [
        {
          id: "大学专科",
          name: "大学专科",
        },
        {
          id: "大学本科",
          name: "大学本科",
        },
        {
          id: "在职硕士",
          name: "在职硕士",
        },
        {
          id: "硕士在读",
          name: "硕士在读",
        },
        {
          id: "硕士研究生",
          name: "硕士研究生",
        },
        {
          id: "博士在读",
          name: "博士在读",
        },
        {
          id: "博士研究生",
          name: "博士研究生",
        },
        {
          id: "其他",
          name: "其他",
        },
      ],
      userInfo: {},
      titleOneList: [],
      subjectList: [
        { required: true, message: "学科领域不能为空", trigger: "change" },
      ],
      subjects: [], //研究方向
      indexs: 0,
      titlsIndex: 0,
      seriesId: "",
      githave: true,
      unitList: [],
      scholarPresentUnit: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    nativeProvince() {
      return this.formValidate.nativeProvince;
    },
    province() {
      return this.formValidate.province;
    },
  },
  watch: {
    livsTop(items) {
      this.livsTop = items;
      this.gitlist = items;
    },
    nativeProvince(newId, oddId) {
      vm.findCityList(newId, 0);
    },
    province(newId, oddId) {
      vm.findCityList(newId, 1);
    },
    livstGithave(data) {
      vm.formValidate.mobile = data.userName;
    },
    toplist(datas) {
      this.toplist = datas;
      if (this.toplist == 1) {
        vm.getDetail();
        vm.title = "完善个人信息";
      } else if (this.toplist == 0) {
        vm.title = "完善注册信息";
        vm.direction();
        vm.direFlife();
        // if (vm.formDynamic.items.length == 0) {
        // }
        // vm.direction();
        // vm.direFlife(); //研究方向
      }
    },
  },
  created() {},
  mounted() {
    vm = this;
    vm.setting = JSON.parse(sessionStorage.getItem("getRegister"));
    console.log(vm.setting);
    if (this.toplist == 1) {
      vm.getDetail();
      setTimeout(() => {
        if (vm.formDynamic.items.length == 0) {
          vm.formDynamic.items = [
            {
              subjectName: "",
              subtwoName: "",
              subthreeName: "",
              index: vm.indexs,
              titleTwoLists: [],
              vahrsThree: [],
              status: 1,
              id: "",
              levelOneName: "",
              levelThreeName: "",
              levelTwoName: "",
              userId: "",
              levelTwo: "",
            },
          ];
          if (vm.formDynamics.titles.length == 0) {
            vm.formDynamics.titles = [
              {
                levelOneName: "",
                levelTwoName: "",
                levelThreeName: "",
                TwoLists: [],
                ThreeLists: [],
                index: 0,
                status: 1,
                levelTwo: "",
                levelOne: "",
                levelTwo: "",
                levelThree: "",
                userId: "",
                id: "",
              },
            ];
          }
        }
      }, 600);
    } else if (this.toplist == 0) {
      vm.formValidate.mobile = vm.livstGithave.userName;
      vm.formDynamic.items = [
        {
          subjectName: "",
          subtwoName: "",
          subthreeName: "",
          index: vm.indexs,
          titleTwoLists: [],
          vahrsThree: [],
          status: 1,
          id: "",
          levelOneName: "",
          levelThreeName: "",
          levelTwoName: "",
          userId: "",
          levelTwo: "",
        },
      ];
      vm.formDynamics.titles = [
        {
          levelOneName: "",
          levelTwoName: "",
          levelThreeName: "",
          TwoLists: [],
          ThreeLists: [],
          index: 0,
          status: 1,
          levelTwo: "",
          levelOne: "",
          levelTwo: "",
          levelThree: "",
          userId: "",
          id: "",
        },
      ];
    }
    setTimeout(() => {
      vm.direction();
      vm.direFlife();
      vm.findProvinceList();
      vm.getEduDictionary(); //学历
    }, 1000);
  },
  methods: {
    resetUnitAddress(value, hasValidate) {
      if (value !== undefined && hasValidate) {
        this.$nextTick(() => {
          let validateKey = value ? 'address' : 'unitAddress'
          this.$refs["formValidate"].validateField(`${validateKey}`);
        })
      }
    },
    //学历
    getEduDictionary() {
      this.$apis.manage.getEduDictionary().then((res) => {
        if (res.resultCode == 200) {
          res.data.forEach((item) => {
            item.children = item.childrens;
          });
          this.eduNewData = res.data;
        }
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    periodicalLogoSuccess(res) {
      console.log(res);
      this.$set(this.formValidate, "headPhoto", res.content.url);
    },
    lodingEnter() {
      var data = {
        userName: this.livstGithave.userName,
        password: this.livstGithave.password,
      };
      vm.$apis.manage.login(data, this.$global.url3).then((res) => {
        if (res.resultCode == 200) {
          sessionStorage.setItem("account", res.content.account);
          sessionStorage.setItem("token", res.content.user.tokenJwtSign);
          //window.location.href = window.location.protocol +`/?token=${user.tokenJwtSign}`+'#/manage/author'
        } else {
          vm.$Message.destroy();
          vm.$Message.warning(res.resultDesc);
        }
      });
    },
    cancive() {
      if (this.cert) {
        this.$parent.livsTop = false;
        return;
      }
      vm.formValidate = {
        nickname: "",
        sex: "",
        birthday: "",
        nation: "",
        nativeProvince: "",
        nativeCity: "",
        province: "",
        city: "",
        eduVal: "",
        mobile: "",
        qq: "",
        email: "",
        unit: "",
        department: "",
        title: "",
        subjectArray: "",
        profile: "",
        id: "",
        userId: "",
      };
      vm.formDynamic.items = [
        {
          subjectName: "",
          subtwoName: "",
          subthreeName: "",
          index: vm.indexs,
          titleTwoLists: [],
          vahrsThree: [],
          status: 1,
          id: "",
          levelOneName: "",
          levelThreeName: "",
          levelTwoName: "",
          userId: "",
          levelTwo: "",
        },
      ];
      vm.formDynamics.titles = [
        {
          levelOneName: "",
          levelTwoName: "",
          levelThreeName: "",
          TwoLists: [],
          ThreeLists: [],
          index: 0,
          status: 1,
          levelTwo: "",
          levelOne: "",
          levelTwo: "",
          levelThree: "",
          userId: "",
          id: "",
        },
      ];
      this.gitlist = false;
      setTimeout(() => {
        vm.$router.go(0);
      }, 1000);
      this.$emit("gitlist", this.gitlist);
    },
    //添加研究方向
    handleAdd() {
      vm.indexs++;
      vm.formDynamic.items.push({
        index: vm.indexs,
        id: "",
        levelOne: "",
        levelOneName: "",
        levelTwo: "",
        levelTwoName: "",
        userId: "",
        levelTwo: "",
      });
    },
    //研究方向改变
    subjectChange(value, selectedData) {
      vm.subjects.push({
        levelOne: value[0],
        levelOneName: selectedData[0].label,
        levelTwo: value[1],
        levelTwoName: selectedData[1].label,
        levelTotal: [value[0], value[1]],
      });
    },
    //删除研究方向
    handleRemove(index) {
      vm.formDynamic.items.splice(index, 1);
    },
    //删除职称
    handleRerve(index) {
      vm.formDynamics.titles.splice(index, 1);
    },
    //添加职称
    titlesAdd() {
      vm.titlsIndex++;
      vm.formDynamics.titles.push({
        levelOneName: "",
        levelTwoName: "",
        levelThreeName: "",
        TwoLists: [],
        ThreeLists: [],
        index: 0,
        status: 1,
        levelTwo: "",
        levelOne: "",
        levelTwo: "",
        levelThree: "",
        userId: "",
        id: "",
      });
    },
    //研究方向
    direFlife() {
      // vm.$apis.manage.direFlife().then((result) => {
      //   this.titleOneList = result.content.researchOneList;
      // });
      vm.$apis.manage.getRelationList().then((res) => {
        if (res.resultCode == 200) {
          vm.subjectList = res.data;
        }
      });
    },

    //研究方向二级
    seconFlife(ids, index) {
      var params = {
        prevSubjectId: ids,
      };
      vm.$apis.manage.seconFlife(params).then((result) => {
        this.formDynamic.items[index].titleTwoLists =
          result.content.researchTwoList;
      });
    },
    //研究方向三级
    seThrFlife(ids, index) {
      var params = {
        prevSubjectId: ids,
      };
      vm.$apis.manage.seThrFlife(params).then((result) => {
        this.formDynamic.items[index].vahrsThree =
          result.content.researchThreeList;
      });
    },
    selectone(data, index) {
      vm.seconFlife(data, index);
      this.formDynamic.items[index].subthreeName = "";
      this.formDynamic.items[index].levelTwo = "";
    },
    selecttwo(data, index) {
      vm.seThrFlife(data, index);
      this.formDynamic.items[index].subthreeName = "";
      this.formDynamic.items[index].levelTwo = "";
    },

    //职称
    direction() {
      vm.$apis.manage.direction().then((res) => {
        res.data.map((item) => {
          vm.getOneList.push({
            value: item.titleCode,
            label: item.titleName,
            level: 1,
          });
        });
      });
      // vm.$apis.manage.direction().then((result) => {
      //   this.getOneList = result.content.titleOneList;
      //   this.getOneList.unshift({ seriesId: "0", seriesName: "其他" });
      // });
    },
    //职称二级
    // secondary(data, id) {
    //   //seriesId
    //   vm.seriesId = data;
    //   var params = {
    //     seriesId: data,
    //   };
    //   vm.$apis.manage.secondary(params).then((result) => {
    //     vm.formDynamics.titles[id].TwoLists = result.content.titleTwoList;
    //   });
    // },
    oneList(data, id) {
      //vm.secondary(data, id);
      this.formDynamics.titles[id].levelOne = data;
      this.formDynamics.titles[id].levelTwo = "";
      this.formDynamics.titles[id].levelTwo = "";
    },
    // twoList(data, id) {
    //   vm.seThreeList(data, id);
    //   this.formDynamics.titles[id].levelThreeName = "";
    //   this.formDynamics.titles[id].levelTwo = "";
    // },

    // //职称三级
    // seThreeList(data, id, data2) {
    //   //seriesId      gradeId
    //   var params = {
    //     seriesId: data2 ? data2 : this.seriesId,
    //     gradeId: data,
    //   };
    //   vm.$apis.manage.seThreeList(params).then((result) => {
    //     vm.formDynamics.titles[id].ThreeLists = result.content.titleThreeList;
    //     // console.log(result);
    //   });
    // },

    //省-市信息
    findProvinceList() {
      this.$apis.manage.provinceCityTree().then((res) => {
        if (res.resultCode == "200") {
          res.data.map((item) => {
            let childrenList = [];
            item.children.map((child) => {
              childrenList.push({
                label: child.name,
                value: child.code,
              });
            });
            this.unitList.push({
              label: item.name,
              value: item.code,
              children: childrenList,
            });
          });
        }
      });
    },

    // 学历选择禁用
    eduNewDataChange(value) {
      if (value[1] == "5" || value[1] == "8" || value[1] == "10") {
        this.formValidate.inStudy = false;
        this.inStudyDisabled = true;
      } else {
        this.inStudyDisabled = false;
      }
    },

    // 单位地址cascade 级联数据变化
    unitAddressChange(value, selectedData) {
      // ['150000', '150100']  [{label: '内蒙古自治区', value: '150000'},{label: '呼和浩特市', value: '150100', __label: '内蒙古自治区 / 呼和浩特市', __value: '150000,150100'}]
      if (value.length > 0) {
        vm.formValidate.province = value[0];
        vm.formValidate.city = value[1];
      } else {
        // 清空操作
        vm.formValidate.province = "";
        vm.formValidate.city = "";
      }
    },
    //省
    rovinceChange(val) {
      vm.formValidate.nativeCity = "";
      vm.cityList = [];
      vm.findCityList(val, 0);
      vm.formValidate.nativeProvince = val || "";
      vm.ruleValidate.nativeCity[0].required = true;
      this.$refs.formValidate.validateField("nativeCity");
    },
    //省
    rovinceChange1(val) {
      vm.formValidate.city = "";
      vm.cityList1 = [];
      vm.findCityList(val, 1);
      vm.ruleValidate.city[0].required = true;
      this.$refs.formValidate.validateField("city");
    },
    //城市
    changeCity(val) {
      vm.formValidate.nativeCity = val;
      vm.ruleValidate.nativeCity[0].required = false;
    },
    //城市
    changeCity1(val) {
      console.log(val);
      vm.formValidate.city = val;
      vm.ruleValidate.city[0].required = false;
    },
    //学历
    selectOption(value) {
      vm.formValidate.education = value;
    },
    //添加回显效果轮循循
    getDetail() {
      vm.$apis.manage.getUserInfo().then((res) => {
        if (res.resultCode == "200") {
          //添加回显
          vm.userInfo = res.content.detail.userInfo;
          var user = res.content.detail.sysUser;
          if (vm.userInfo != undefined) {
            let resObj = Object.assign({}, res.content.detail.userInfo);
            if (res.content.detail.sysUserSubject != undefined) {
              resObj.sysUserSubject = [...res.content.detail.sysUserSubject];
            }
            for (const key in vm.formValidate) {
              vm.formValidate[key] = resObj[key];
            }
            vm.formValidate.inStudy =
              vm.formValidate.inStudy != undefined
                ? vm.formValidate.inStudy == 1
                  ? true
                  : false
                : false;
            // realname
            vm.formValidate.nickname = vm.userInfo.nickname
              ? vm.userInfo.nickname
              : vm.userInfo.realname;

            if (vm.userInfo.sex == "0") {
              vm.formValidate.sex = "女";
            } else if (vm.userInfo.sex == "1") {
              vm.formValidate.sex = "男";
            }
            // vm.formValidate.job = vm.userInfo.job;
            vm.formValidate.researchDirection = vm.userInfo.researchDirection;
            vm.formValidate.id = vm.userInfo.id;
            vm.formValidate.mobile = sessionStorage.getItem("account");
            let nationPlace = vm.userInfo.nationPlace;
            vm.formValidate.nativeProvince = nationPlace
              ? nationPlace.split(",")[0]
              : "";
            vm.formValidate.nativeCity = nationPlace
              ? nationPlace.split(",")[1]
              : "";
            this.$set(
              vm.formValidate,
              "job",
              vm.formValidate.job != undefined ? vm.formValidate.job : ""
            );
            this.$set(
              vm.formValidate,
              "headPhoto",
              vm.formValidate.headPhoto != undefined
                ? vm.formValidate.headPhoto
                : ""
            );

            // 单位地址，级联数据
            if (res.content.detail.scholarPresentUnit.length) {
              vm.scholarPresentUnit = res.content.detail.scholarPresentUnit;
              let scholarPresentUnit = vm.scholarPresentUnit[0];
              vm.formValidate.country = scholarPresentUnit.country;
              vm.formValidate.address = scholarPresentUnit.address;
              if (
                vm.userInfo.province != "" &&
                typeof vm.userInfo.province != "undefined"
              ) {
                vm.formValidate.province = scholarPresentUnit.province;
                vm.formValidate.city = scholarPresentUnit.city;
                vm.formValidate.unitAddress = [
                  scholarPresentUnit.province,
                  scholarPresentUnit.city,
                ];
              }
            }

            if (
              res.content.detail.sysUserSubject &&
              res.content.detail.sysUserSubject.length != 0
            ) {
              vm.formDynamic.items = res.content.detail.sysUserSubject.map(
                (item) => {
                  this.$set(item, "levelTotal", [item.levelOne, item.levelTwo]);
                  return item;
                }
              );
              this.listdata = true;
            } else {
              vm.formDynamic.items = [
                {
                  index: 0,
                  status: 1,
                  id: "",
                  levelOne: "",
                  levelOneName: "",
                  levelTwo: "",
                  levelTwoName: "",
                  userId: "",
                  levelTwo: "",
                },
              ];
            }
            //职称回显
            if (
              res.content.detail.sysUserTitle &&
              res.content.detail.sysUserTitle.length != 0
            ) {
              var listsu = res.content.detail.sysUserTitle;
              listsu.map((item, index) => {
                vm.titlsIndex = index;
                vm.formDynamics.titles.push({
                  levelOneName: item.levelOneName,
                  levelOne: item.levelOne,
                  levelTwo: item.levelTwo,
                  userId: item.userId,
                  id: item.id,
                  index: 0,
                  status: 1,
                  levelTwo: item.levelTwo,
                });
              });
            } else {
              vm.formDynamics.titles = [
                {
                  levelOneName: "",
                  index: 0,
                  status: 1,
                  levelTwo: "",
                  levelOne: "",
                  levelTwo: "",
                  userId: "",
                  id: "",
                },
              ];
            }
          } else {
            vm.formValidate = {
              ...vm.formValidate,
              ...user
            };
            vm.formValidate.mobile = sessionStorage.getItem("account");
          }
        } else {
          vm.$Message.warning(res.resultDesc);
        }
      });
    },
    //保存修改
    handleSubmit(name, names, nametitle) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$refs[names].validate((valid) => {
            if (valid) {
              this.$refs[nametitle].validate((valid) => {
                if (valid) {
                  var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_.-]+(\\.[a-zA-Z0-9_.-]+)*\.[a-zA-Z0-9_.-]{2,6}$/;
                  var regName = /^[\u4e00-\u9fa5a-zA-Z· ]+$/;
                  if (!regName.test(vm.formValidate.nickname)) {
                    this.$Message.error(
                      "请输入正确格式的姓名，不要包含特殊字符"
                    );
                    return false;
                  }
                  if (!reg.test(vm.formValidate.email)) {
                    vm.$Message.error("请输入正确格式的邮箱");
                    return;
                  }
                  vm.formValidate.birthday = vm.formValidate.birthday
                    ? vm.$global.getYear(vm.formValidate.birthday) + "-01-01"
                    : "";
                  vm.formValidate.realname = vm.formValidate.nickname;
                  vm.formValidate.nationPlace =
                    vm.formValidate.nativeProvince +
                    "," +
                    vm.formValidate.nativeCity;

                  if (vm.formValidate.country === 0) {
                    vm.formValidate.address = "";
                  } else if (vm.formValidate.country === 1) {
                    vm.formValidate.unitAddress = [];
                    vm.formValidate.province = "";
                    vm.formValidate.city = "";
                  } else {
                    vm.formValidate.country = "";
                    vm.formValidate.address = "";
                    vm.formValidate.unitAddress = [];
                    vm.formValidate.province = "";
                    vm.formValidate.city = "";
                  }
                  vm.scholarPresentUnit[0] = {
                    ...vm.scholarPresentUnit[0],
                    ...{
                      unitName: vm.formValidate.unit,
                      job: vm.formValidate.job,
                      country: vm.formValidate.country,
                      province: vm.formValidate.province,
                      city: vm.formValidate.city,
                      address: vm.formValidate.address,
                    },
                  };

                  //保存学历存值
                  this.eduNewData.forEach((item) => {
                    item.children.forEach((items) => {
                      if (this.formValidate.eduVal[1] == items.value) {
                        this.formValidate.education = items.label;
                      }
                    });
                  });
                  this.formValidate.eduVal = vm.formValidate.eduVal.toString();
                  var formValidate = vm.$global.deepClone(vm.formValidate);
                  formValidate.inStudy = formValidate.inStudy ? "1" : "0";
                  //研究方向
                  if (this.setting[13].show) {
                    var sub = [];
                    sub = vm.$global.deepClone(vm.formDynamic.items);
                    sub.map((it) => {
                      it.levelOne = it.levelTotal[0];
                      it.levelTwo = it.levelTotal[1];
                    });
                    //职称
                    vm.formDynamics.titles.map((itmes) => {
                      itmes.levelTwo = itmes.levelTwo;
                      return itmes;
                    });
                    vm.formDynamic.items = vm.formDynamic.items.filter(Boolean);
                  }
                  var num = 0;
                  vm.formDynamics.titles.map((itdd) => {
                    if (
                      !itdd.levelTwo &&
                      !itdd.levelTwo &&
                      itdd.levelOne != "5"
                    ) {
                      this.$Message.error("职称不能为空！");
                      return (num += 1);
                    }
                  });
                  if (num == 0) {
                    var dattop = {
                      scholarPresentUnits: vm.scholarPresentUnit,
                      userInfo: vm.$global.copyObj(formValidate),
                      subjects: sub,
                      titles: vm.formDynamics.titles,
                    };
                    console.log(dattop);
                    //return
                    if (vm.toplist == 1) {
                      vm.$apis.manage.editModifyBaseInfo(dattop).then((res) => {
                        if (res.resultCode == 200) {
                          this.$Message.success("完善个人信息成功！");
                          if (this.cert) {
                            setTimeout(function() {
                              location.reload();
                            }, 500);
                            return;
                          }
                          setTimeout(function() {
                            vm.$router.push({
                              path: "/manage/author",
                            });
                          }, 100);
                        } else {
                          this.$Message.error(res.resultDesc);
                        }
                      });
                    } else if (vm.toplist == 0) {
                      vm.lodingEnter();
                      setTimeout(function() {
                        vm.$apis.manage
                          .editModifyBaseInfo(dattop)
                          .then((res) => {
                            if (res.resultCode == 200) {
                              vm.$Message.success("认证成功！");
                              // sessionStorage.removeItem("token");
                              vm.$router.push({
                                path: "/manage/author",
                              });
                            } else {
                              vm.$Message.error(res.resultDesc);
                            }
                          });
                      }, 1000);
                    }
                  }
                } else {
                  this.$Message.destroy();
                  setTimeout(function() {
                    vm.$Message.error("请完善职称！");
                  }, 500);
                }
              });
            } else {
              this.$Message.destroy();
              setTimeout(function() {
                vm.$Message.error("请完善学科领域！");
              }, 500);
            }
          });
        } else {
          this.$Message.destroy();
          setTimeout(function() {
            vm.$Message.error("请填写必要信息！");
          }, 500);
        }
      });
    },
    buttons() {
      this.$router.push({
        path: "/cardCollection",
        query: {
          editId: this.$route.query.editId,
          perId: this.$route.query.perId,
          userId: this.userId ? this.userId : "",
        },
      });
    },
    //退出
    // logOut() {
    //   this.$apis.manage.logOut().then((res) => {
    //     if (res.resultCode == "200") {
    //       this.$Message.success("退出成功!");
    //       sessionStorage.removeItem("token");
    //       window.location.href =
    //         window.location.protocol +
    //         "//" +
    //         window.location.host +
    //         "/" +
    //         window.location.search;
    //     } else {
    //       this.$Message.error(res.resultDesc);
    //     }
    //   });
    // },
  },
};
</script>

<style scoped="scoped" lang="scss">
.content-box2 {
  padding-bottom: 20px;
  overflow-y: auto !important;
  /* min-height: calc(100vh - 135px) !important; */
}
.save {
  width: 150px;
  height: 40px;
  display: block;

  background: #4064e1;
  color: #fff;
  border-radius: 20px;
  /* margin-left: 220px;
	    margin-top: 70px; */
}
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/* .save {
  width: 150px;
  height: 40px;
  display: block;
  margin: 0 auto;
  background: #4064e1;
  color: #fff;
  border-radius: 20px;
  /* margin-left: 220px;
	    margin-top: 70px; 
} */
/deep/ textarea {
  width: 500px !important;
}
.content {
  /* background: #fff; */
  /*	width: 1200px;
		 margin: 0 auto; */
  height: 600px;
  overflow-y: scroll;
  padding-left: 30px;
  padding-right: 50px;
  padding-bottom: 30px;
}
.wrapperd {
  padding: 0;
  padding-top: 10px;
}
.content-box2 {
  padding-bottom: 20px;
  overflow-y: auto !important;
  min-height: calc(100vh - 135px) !important;
}
.listgit {
  position: relative;
}
.havelist {
  display: flex;
  position: absolute;
  top: 250px;
  left: 0px;
}
.listTop /deep/ .ivu-form-item-content {
  // margin-left: 20px !important;
}

/deep/.ivu-input {
  width: 90% !important;
}
.address-input {
  margin-left: 10px;
  width: 300px;
  /deep/ .ivu-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/certification/index.vue